import { ClientFile, ClientFileType, InfoBlock } from '@codegen';
import { InfoBlockForShow } from '@modules/documents/documents.interface';
import {
  DocumentsAction,
  DocumentsActionTypes,
} from '@modules/documents/store/documents.actions';

export class DocumentsState {
  public needed?: ClientFileType[] = null;
  public uploaded?: ClientFile[] = null;
  public infoBlock?: InfoBlock;
  public infoBlockForShow?: InfoBlockForShow = {
    isShowing: false,
    infoBlock: null,
  };
}

export function reducer(
  state = new DocumentsState(),
  action: DocumentsAction
): DocumentsState {
  switch (action.type) {
    case DocumentsActionTypes.LoadDocumentsSuccess: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case DocumentsActionTypes.IsInfoBlockShowed: {
      return {
        ...state,
        infoBlockForShow: {
          isShowing: action.payload,
          infoBlock: state.infoBlock,
        },
      };
    }
    case DocumentsActionTypes.MarkDocumentAsViewed: {
      return {
        ...state,
        uploaded: state.uploaded.map(file => {
          if (file.fileId === action.fileId) {
            return {
              ...file,
              unread: false,
            };
          }
          return file;
        }),
      };
    }
    case DocumentsActionTypes.SetNeededDocuments: {
      return {
        ...state,
        needed: action.payload ? action.payload : null,
      };
    }
    case DocumentsActionTypes.SetUploadedDocuments: {
      return {
        ...state,
        uploaded: action.payload ? action.payload : null,
      };
    }
    case DocumentsActionTypes.SignedDocument: {
      return {
        ...state,
        uploaded: state.uploaded.map(file => {
          if (file.fileId === action.fileId) {
            return {
              ...file,
              needSign: false,
            };
          }
          return file;
        }),
      };
    }
    case DocumentsActionTypes.UpdateDocument: {
      return {
        ...state,
        uploaded: state?.uploaded?.map(i => {
          if (i.fileId === action.file.fileId) {
            return action.file;
          }
          return i;
        }),
      };
    }
    case DocumentsActionTypes.DeletedDocument: {
      return {
        ...state,
        uploaded: state.uploaded.filter(i => i.fileId !== action.fileId),
      };
    }
    default: {
      return state;
    }
  }
}
